var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconResourcesPlayVideoCpt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-resources-play-video-cpt_svg__clip0_2207_48649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.32 10.61L1.78.16A1.022 1.022 0 001.174 0C.964.015.761.095.583.235.404.374.257.57.155.802A1.891 1.891 0 000 1.56v20.88c0 .265.053.526.155.758.102.232.25.427.428.567.178.14.381.22.591.234.21.013.419-.042.607-.16L18.32 13.39c.206-.127.378-.325.5-.57.12-.246.184-.53.184-.82 0-.288-.064-.572-.185-.817a1.387 1.387 0 00-.499-.572z",
    fill: "#002147"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-resources-play-video-cpt_svg__clip0_2207_48649"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h19v24H0z"
  })))));
}
export default SvgIconResourcesPlayVideoCpt;